import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppsettingsConfig } from '../../client-config/models/client-config';
import {
  IRegistrationRequestEditFormData,
  RegistrationRequestDto,
  RegistrationRequestHistoryDto,
} from 'src/app/core/models/registration-request.model';
import { IResponseRegister } from 'src/app/core/models/RegisterStrangerRequest';
import IStrangersType from '../models/interfaces/IStrangersType';

@Injectable({
  providedIn: 'root',
})
export class RegistrationRequestsService {
  registrationRequestsUrl: string;
  accountRequestsUrl: string;

  constructor(
    private http: HttpClient,
    private appsettings: AppsettingsConfig
  ) {
    this.registrationRequestsUrl = `${appsettings.backendUrl}/request`;
    this.accountRequestsUrl = `${appsettings.backendUrl}/account`;
  }

  getUserCard(requestNumber: string, clientMnemonic: string): Observable<RegistrationRequestDto> {
      return this.http.get<RegistrationRequestDto>(`${this.registrationRequestsUrl}/card/${requestNumber}/${clientMnemonic}`);
  }

  getHistory(requestNumber: string, clientMnemonic: string): Observable<RegistrationRequestHistoryDto[]> {
      return this.http.get<RegistrationRequestHistoryDto[]>(`${this.registrationRequestsUrl}/history/${requestNumber}/${clientMnemonic}`);
  }

  updateRequest(data: FormData): Observable<IResponseRegister> {
    return this.http.post<IResponseRegister>(`${this.accountRequestsUrl}/stranger/register`, data);
  }

  getInitialEditRequestFormData(
    registrationRequest: RegistrationRequestDto,
    typeUser: IStrangersType | null,
    personalCountryName?: string,
    orgCountryName?: string
  ): IRegistrationRequestEditFormData {
    return {
      personalData: {
        firstname: registrationRequest.firstname || '',
        surname: registrationRequest.surname || '',
        patronymic: registrationRequest.patronymic || '',
        inn: registrationRequest.inn || '',
        address: registrationRequest.address || '',
        countryId: registrationRequest.countryId ? String(registrationRequest.countryId) : '',
        countryName: personalCountryName || '',
      },
      organizationData: {
        olf: registrationRequest.orgOlf || '',
        shortName: registrationRequest.orgShortname || '',
        fullName: registrationRequest.orgFullname || '',
        email: registrationRequest.orgEmail || '',
        inn: registrationRequest.orgInn || '',
        address: registrationRequest.orgAddress || '',
        countryId: registrationRequest.orgCountryId ? String(registrationRequest.orgCountryId) : '',
        countryName: orgCountryName || '',
        phone: registrationRequest.orgPhone || '',
        phoneCountryCode: '',
        taxAuthority: registrationRequest.orgTaxAuthority || '',
      },
      phoneOrganization: {
        phoneNumber: registrationRequest.orgPhone || '',
        phoneCountryCode: registrationRequest.orgPhoneCountryCode || '',
      },
      clients: [],
      typeUser,
    };
  }

  getUpdateRequestFormData(editData: IRegistrationRequestEditFormData, registrationRequest: RegistrationRequestDto): FormData {
    const formData = new FormData();
    const selectedMnemonics = editData.clients.filter((c) => c.checked).map((c) => c.mnemonic);

    const data = {
      type: editData.typeUser?.id,
      clientMnemonics: selectedMnemonics,
      requestNumber: registrationRequest.requestNumber,
      personalData: {
        surname: editData.personalData.surname,
        firstname: editData.personalData.firstname,
        patronymic: editData.personalData.patronymic,
        countryId: editData.personalData.countryId ? Number(editData.personalData.countryId) : undefined,
        address: editData.personalData.address,
        email: registrationRequest.email,
        phoneCountryCode: registrationRequest.phoneCountryCode,
        phone: registrationRequest.phone,
        inn: editData.personalData.inn,
        taxAuthority: registrationRequest.taxAuthority,
      },
      organization: {
        olf: editData.organizationData.olf,
        shortName: editData.organizationData.shortName,
        fullName: editData.organizationData.fullName,
        countryId: editData.organizationData.countryId ? Number(editData.organizationData.countryId) : undefined,
        address: editData.organizationData.address,
        email: editData.organizationData.email,
        phoneCountryCode: editData.phoneOrganization.phoneCountryCode,
        phone: editData.phoneOrganization.phoneNumber,
        inn: editData.organizationData.inn,
        taxAuthority: editData.organizationData.taxAuthority,
      },
    };
    formData.append('Data', JSON.stringify({ ...data }));
    return formData;
  }
}
